/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Clients_Score_LeadInputs */

const cs_clients_score_lead = /** @type {(inputs: Clients_Score_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lead ${i?.n}`)
};

const en_clients_score_lead = /** @type {(inputs: Clients_Score_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lead ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Lead {n}" |
*
* @param {Clients_Score_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_score_lead = /** @type {((inputs: Clients_Score_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Score_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_score_lead(inputs)
	return cs_clients_score_lead(inputs)
});